import type { JSX } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './input.styles';
interface InputProps extends Omit<JSX.IntrinsicElements['input'], 'ref'> {
  /** Monospace — for MACs, codes, IDs **and figures**.
   *
   * Figures too, because this app already renders them monospace everywhere it
   * DISPLAYS them (`cycle_days`, `seq`, `trays_per_layer`, every threshold band),
   * so a sans input made the same number change font between being read and
   * being edited. A placeholder stays sans: it is prose, not a value. */
  mono?: boolean;
  /** Marks the field invalid: danger border + danger focus ring + aria-invalid. */
  invalid?: boolean;
}
export function Input({
  mono = false,
  invalid = false,
  ...props
}: InputProps) {
  return <input {...props} aria-invalid={invalid || undefined} {...stylex.props(styles.input, mono && styles.mono, invalid && styles.invalid)} />;
}